import { Grid, Typography } from "@material-ui/core";
import SwitchButton from "components/common/SwitchButton/SwitchButton";
import { EXPRESS_TYPES, STATUS } from "../../config/constants";
import { ChangeEvent } from "react";
import TextBox from "components/common/TextBox";
import { ReactComponent as EditIcon } from "../assets/svg/Pencil.svg";
import { COUNTRY_SETTING_TEXT_CONSTANT } from "./CountrySettingsUtils";
import { isEmptyOrNull } from "../../utils/DataUtils";
import { ON_OFF_OPTIONS } from "components/common/App/app-constant";
import RadioGroupField from "components/common/RadioGroupField/RadioGroupField";

interface PosTabInfoProps {
  readonly element: { displayName: string, count?: string | number };
  readonly classes: any;
}

export function PosTabInfo(props: Readonly<PosTabInfoProps>) {
  const { classes, element } = props;

  return (
    <Grid container spacing={0} justifyContent="space-between" className={classes.activePOSGridInnerContainer}>
      <Grid item className={classes.activePOSGridInnerItem}>
        <Typography className={classes.serviceTypeStyle}>{element.displayName}</Typography>
      </Grid>
      <Grid item className={classes.activePOSGridInnerItem}>
        <Typography className={classes.serviceTypeCountData}>{element?.count ?? "-"}</Typography>
      </Grid>
    </Grid>
  );
}

interface PlasticBagconfigurationViewUtilsInterface {
  classes: any;
  bagChargeEnabled: boolean;
  itemsPerBag: number | string;
  bagCharges: number | string;
  editBagCharge: boolean;
  handleBagChargeChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handlePlasticBagChange: (event: ChangeEvent<HTMLInputElement>, name: string) => void;
  handleEditBagCharges: (name: string) => void;
  name: string;
  newPlasticBagCharges: {
    itemsPerBag: number | string;
    bagCharges: number | string;
  };
}

export const PlasticBagconfigurationViewUtils = (props: PlasticBagconfigurationViewUtilsInterface) => {
  const {
    classes,
    bagChargeEnabled,
    itemsPerBag,
    bagCharges,
    editBagCharge,
    handleBagChargeChange,
    handlePlasticBagChange,
    handleEditBagCharges,
    name,
    newPlasticBagCharges
  } = props;

  const plasticBagLabel = (
    <>
      <Typography>{`${COUNTRY_SETTING_TEXT_CONSTANT.PLASTIC_BAG_CHARGE_ENABLED}`}</Typography>
      {!editBagCharge && <EditIcon className={classes.iconButton} onClick={() => handleEditBagCharges(name)} />}
    </>
  );

  return (
    <Grid item xs={3}>
      <Grid container>
        <RadioGroupField
          labelContent={plasticBagLabel}
          name={name}
          value={bagChargeEnabled}
          options={ON_OFF_OPTIONS}
          disabled={!editBagCharge}
          handleChange={handleBagChargeChange}
          classes={classes}
          xs={12}
        />
        {bagChargeEnabled && <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6} className={classes.serviceTypeContentTitle}>
              {`${COUNTRY_SETTING_TEXT_CONSTANT.NUMBER_OF_ITEMS_PER_BAG}`}
            </Grid>
            <Grid item xs={6} className={classes.serviceTypeContentTitle}>
              {`${COUNTRY_SETTING_TEXT_CONSTANT.PRICE_PER_BAG}`}
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextBox
                name="itemsPerBag"
                textBoxId="itemsPerBag"
                placeholderText={`${COUNTRY_SETTING_TEXT_CONSTANT.NUMBER_OF_ITEMS_PER_BAG}`}
                value={editBagCharge ? newPlasticBagCharges.itemsPerBag : itemsPerBag}
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handlePlasticBagChange(event, name)}
                className={classes.textBoxpaddingStyle}
                disabled={!editBagCharge}
              ></TextBox>
            </Grid>
            <Grid item xs={6}>
              <TextBox
                name="bagCharges"
                textBoxId="bagCharges"
                placeholderText={COUNTRY_SETTING_TEXT_CONSTANT.PRICE_PER_BAG}
                value={editBagCharge ? newPlasticBagCharges.bagCharges : bagCharges}
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handlePlasticBagChange(event, name)}
                className={classes.textBoxpaddingStyle}
                disabled={!editBagCharge}
              ></TextBox>
            </Grid>
          </Grid>
        </Grid>}
      </Grid>
    </Grid>
  );
};

interface ServiceActiveFlagViewUtilsInterface {
  classes: any;
  serviceTypeName: string;
  serviceActiveFlag: boolean;
  isDisabled: boolean;
  handleServiceTypeActiveChange: (event: React.ChangeEvent<HTMLInputElement>, serviceTypeName: string) => void;
}

export const ServiceActiveFlagViewUtils = (props: ServiceActiveFlagViewUtilsInterface) => {
  const { classes, serviceTypeName, serviceActiveFlag, isDisabled, handleServiceTypeActiveChange } = props;
  return (
    <Grid item xs={12} className={isDisabled ? classes.enableServiceTypeGridMainDisabled : classes.enableServiceTypeGridMain}>
      <Grid container spacing={0} justifyContent="flex-end" className={classes.enableServiceTypeGridConatiner}>
        <Grid item className={classes.enableServiceTypeGridItem}>
          <Typography className={classes.enableServiceTypeGridItemTextStyle}>{`${COUNTRY_SETTING_TEXT_CONSTANT.ENABLE_SERVICE_TYPE}`}</Typography>
        </Grid>
        <Grid item className={classes.enableServiceTypeSwitchGridItem}>
          <SwitchButton
            className={!isDisabled ? classes.switchStyle : classes.disableSwitch}
            size="small"
            checked={serviceActiveFlag}
            disabled={isDisabled}
            handleChange={(e: ChangeEvent<HTMLInputElement>) => handleServiceTypeActiveChange(e, serviceTypeName)}
            leftLabel={undefined}
            rightLabel={undefined}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

interface ServiceTypeBasicDetailsInterface {
  classes: any;
  serviceTypeName: string;
  serviceActiveStatus?: string;
  nextDaySlotVisibilityStatus?: string | boolean;
  editSlotDaysStatus?: string | number;
  plasticBagChargeStatus: string;
  expressTypeStatus?: string;
  advanceSlotDays?: string | number;
  itemsPerBag: string | number;
  bagCharges: string | number;
  newPlasticBagCharges: { itemsPerBag: string | number, bagCharges: string | number };
}

export const ServiceTypeBasicDetails = (props: ServiceTypeBasicDetailsInterface) => {
  const { classes, serviceTypeName, serviceActiveStatus, nextDaySlotVisibilityStatus, editSlotDaysStatus, plasticBagChargeStatus, expressTypeStatus, advanceSlotDays, itemsPerBag, bagCharges, newPlasticBagCharges } = props;

  return (
    <>
      <Grid item xs={12} className={classes.serviceTypeHeaderDetailsGridItem}>
        <Typography className={classes.applyModalBodyTitle}>{`${serviceTypeName ?? ""}`}</Typography>
      </Grid>
      {serviceActiveStatus !== undefined && (
        <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
          <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.SERVICE_TYPE} : `}</Typography>
          <Typography className={serviceActiveStatus === STATUS.ACTIVE ? classes.selectedValuesDataTrue : classes.selectedValuesDataFalse}>{`${serviceActiveStatus}`}</Typography>
        </Grid>
      )}
      {nextDaySlotVisibilityStatus !== undefined && (
        <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
          <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.NEXT_DAY_SLOT_VISIBILITY} : `}</Typography>
          <Typography className={classes.selectedValuesData}>{`${nextDaySlotVisibilityStatus}`}</Typography>
        </Grid>
      )}
      {advanceSlotDays !== undefined && (
        <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
          <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.ADVANCE_SLOT_DAYS} : `}</Typography>
          <Typography className={classes.selectedValuesData}>{`${advanceSlotDays}`}</Typography>
        </Grid>
      )}
      {editSlotDaysStatus !== undefined && (
        <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
          <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.EDITED_ADVANCE_SLOT_DAYS} : `}</Typography>
          <Typography className={classes.selectedValuesData}>{`${editSlotDaysStatus}`}</Typography>
        </Grid>
      )}
      <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
        <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.PLASTIC_BAG_CHARGE} : `}</Typography>
        <Typography className={classes.selectedValuesData}>{`${plasticBagChargeStatus}`}</Typography>
      </Grid>
      {plasticBagChargeStatus === STATUS.ENABLED &&
        <>
          <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
            <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.NUMBER_OF_ITEMS_PER_BAG} : `}</Typography>
            <Typography className={classes.selectedValuesData}>{`${!isEmptyOrNull(newPlasticBagCharges?.itemsPerBag) ? newPlasticBagCharges.itemsPerBag : itemsPerBag ?? "-"}`}</Typography>
          </Grid>
          <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
            <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.PRICE_PER_BAG} : `}</Typography>
            <Typography className={classes.selectedValuesData}>{`${!isEmptyOrNull(newPlasticBagCharges?.bagCharges) ? newPlasticBagCharges.bagCharges : bagCharges ?? "-"}`}</Typography>
          </Grid>
        </>
      }

      {expressTypeStatus !== undefined && (
        <Grid item xs={12} className={classes.serviceTypeDetailsGridItem}>
          <Typography className={classes.applyModalBodyContent}>{`${COUNTRY_SETTING_TEXT_CONSTANT.EXPRESS_TYPE} : `}</Typography>
          <Typography className={classes.selectedValuesData}>{`${expressTypeStatus}`}</Typography>
        </Grid>
      )}      
    </>
  );
};

export const EXPRESS_TYPE_OPTIONS = [
  { value: EXPRESS_TYPES.SLOT_BASED.value, label: EXPRESS_TYPES.SLOT_BASED.label },
  { value: EXPRESS_TYPES.ON_DEMAND.value, label: EXPRESS_TYPES.ON_DEMAND.label },
];
